// 格式化时间 yyyy-MM-dd q hh-mm-ss S
export const formatDate = (
  date: Date | string | number = new Date(),
  fmt: string | number = undefined,
  timezoneOffset: number = -new Date().getTimezoneOffset() / 60
) => {
  if (!(date instanceof Date)) {
    if (typeof date == 'string' && /[yMdhms]/.test(date)) {
      if (typeof fmt == 'number') timezoneOffset = fmt;
      fmt = date;
      date = new Date();
    } else if (!isNaN(+date)) {
      if (+date > 0) {
        date = new Date(+date);
      } else {
        timezoneOffset = +date;
        date = new Date();
      }
    } else if (typeof date == 'string') {
      date = new Date(date.replace(/-/g, '/'));
    }
  }
  fmt = (fmt || 'yyyy-MM-dd') as string;
  date = new Date(+date + timezoneOffset * 3600 * 1000);
  try {
    const o = {
      //月
      'M+': date.getUTCMonth() + 1,
      //日
      'd+': date.getUTCDate(),
      //时
      'h+': date.getUTCHours(),
      //分
      'm+': date.getUTCMinutes(),
      //秒
      's+': date.getUTCSeconds(),
      //季度
      'q+': Math.floor((date.getUTCMonth() + 3) / 3),
      //毫秒
      'S+': date.getUTCMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getUTCFullYear() + '').slice(-RegExp.$1.length));
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('0000' + o[k]).slice(-RegExp.$1.length)
        );
    }
    return fmt;
  } catch (e) {
    return '';
  }
};
// 按间隔在字符串中插入指定间隔符
export function addSplit(
  str: string,
  split: string = ',',
  size: number = 3,
  direction: 'ltr' | 'rtl' = 'rtl'
): string {
  let result = '';
  const offset = direction === 'rtl' && str.length % size ? (str.length % size) - size : 0;
  for (let index = 0; index < str.length; index += size) {
    result = (result ? result + split : '') + str.substring(index + offset, index + size + offset);
  }
  return result;
}
// 格式化金额 默认三位一逗号
export const formatMoney = (num: number | bigint | string, split = ',', size: number = 3) => {
  if (typeof num !== 'number' && typeof num !== 'bigint')
    num = num === '' || isNaN(+num) ? -1 : +num;
  if (num === -1) return '-';
  const number: string = num.toString();
  const [integer, decimal = ''] = number.split(/[-.]/).filter(Boolean);
  return `${num < 0 ? '-' : ''}${addSplit(integer, split, size, 'rtl')}${
    decimal ? '.' : ''
  }${addSplit(decimal, split, size, 'ltr')}`;
};
// 格式化百分数 rate: number
export const formatRate = (rate: number, keepSymbol?: boolean) => {
  if (/[^\d\-+. ]/.test(rate + '') || !/\d/.test(rate + '')) return rate;
  if (!keepSymbol) rate = Math.abs(rate);
  return Math.round(rate * 10000) / 100 + '%';
};
// 数字打码
export function mosaicNumber(num: number | string) {
  if (/^[\d\-.+]+$/.test(num + '')) {
    if (num > 1000) num = ~~((num as number) / 1000) + '000+';
    else if (num > 100) num = ~~((num as number) / 100) + '00+';
    else if (num > 10) num = ~~((num as number) / 10) + '0+';
  }
  return num;
}
// 时间节点
export const time = {
  init(year, month = 0) {
    const date = time.月初;
    year && date.setFullYear(year);
    date.setMonth(month);
    return date;
  },
  get 月初() {
    const time = new Date(~~(Date.now() / 36e5) * 36e5); // 分秒归零
    time.setHours(0); // 设为0点
    time.setDate(1); // 设为1号
    return time;
  },
  get 去年末() {
    return new Date(this.月初.setMonth(-1));
  },
  get 去年初() {
    return new Date(this.月初.setMonth(-12));
  },
  get 前年末() {
    return new Date(this.月初.setMonth(-13));
  },
  get 前年初() {
    return new Date(this.月初.setMonth(-24));
  },
};

export default {
  formatDate,
  addSplit,
  formatMoney,
  formatRate,
  mosaicNumber,
  time,
};
